__turbopack_context__.v({
  "border": "tGky4G_border",
});
